import { useEffect } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { getCities } from '@area-restrita/api-client/endpoints/address/address.gen';

import { BrasilApiService } from '../services/brasilapi';

interface IFormCapAutocompleteProps {
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
}

export const useFormCepAutocomplete = (
  { watch, setValue }: IFormCapAutocompleteProps,
  addressPath?: string,
) => {
  const zipCode = watch(`${addressPath ? `${addressPath}.` : ''}zipCode`, '');

  useEffect(() => {
    (async () => {
      if (zipCode.length < 9) return;

      const cepResponse = await BrasilApiService.getCep(zipCode);
      if (cepResponse.erro) return;

      const cities = await getCities({ externalId: cepResponse.ibge });
      const city = cities.at(0);

      setValue(
        `${addressPath ? `${addressPath}.` : ''}state`,
        city?.state
          ? {
              label: city.state.name,
              value: city.state.id,
            }
          : undefined,
        { shouldValidate: true },
      );
      setValue(
        `${addressPath ? `${addressPath}.` : ''}city`,
        city
          ? {
              label: city.name,
              value: city.id,
            }
          : undefined,
        { shouldValidate: true },
      );

      setValue(
        `${addressPath ? `${addressPath}.` : ''}street`,
        cepResponse.logradouro,
        {
          shouldValidate: true,
        },
      );
      setValue(
        `${addressPath ? `${addressPath}.` : ''}neighborhood`,
        cepResponse.bairro,
        {
          shouldValidate: true,
        },
      );
    })();
  }, [addressPath, zipCode, setValue]);
};
